import { ALL_TRIPS_TRIP_ID } from 'src/routes/trip-analyzer/data/trip-analyzer.constants';
import { isTimestampInWindow } from 'src/routes/trip-analyzer/data/timeWindow';
import { copyText } from 'src/constants/copy/copy.utils';
import { TRIP_ANALYZER_COPY } from 'src/constants/copy/trip-analyzer.copy';

/**
 * Client-side filter for trip catalog items by time window. Real trips outside
 * the window are dropped; the "All trips" sentinel subtext is recomputed against
 * the surviving count. When nothing survives, the sentinel is dropped too.
 *
 * @param {Array<{ id: string, startTs?: string, subtext?: string }>} items
 * @param {string|null|undefined} windowStart
 * @param {string|null|undefined} windowEnd
 * @returns {Array<Object>}
 */
export const filterTripCatalogItemsByTimeWindow = (items = [], windowStart, windowEnd) => {
    if (!windowStart && !windowEnd) {
        return items;
    }

    const realTrips = items.filter((item) => (
        item.id !== ALL_TRIPS_TRIP_ID && isTimestampInWindow(item.startTs, windowStart, windowEnd)
    ));

    if (!realTrips.length) {
        return [];
    }

    const allTripsOption = items.find((item) => item.id === ALL_TRIPS_TRIP_ID);
    if (!allTripsOption) {
        return realTrips;
    }

    return [
        {
            ...allTripsOption,
            subtext: copyText(TRIP_ANALYZER_COPY.tripCatalogAllTripsSubtext).replace('{count}', String(realTrips.length)),
        },
        ...realTrips,
    ];
};
